export default "__VITE_ASSET__72223486__"